<template>
  <div ref="srpSlotRef" class="dcp-cars-srp-second-row-slot"></div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'SecondRowSlot',
});
</script>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { insertSlotManually } from '../../utils/slots';

const srpSlotRef = ref();
const emit = defineEmits(['slot-manually-inserted']);

onMounted(() => {
  const inserted = insertSlotManually('emh-search-result', 'emh-search-result-second-row', srpSlotRef.value);

  if (inserted) {
    emit('slot-manually-inserted');
  }
});
</script>
